import React, { useRef } from 'react'
import { getImages } from '../const'
import { Field, Form, Formik } from 'formik';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import * as Yup from 'yup';

const AddNewAppraisalModal = ({ close }) => {
    const fileInputRef = useRef(null);

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileUpload = (event) => {
        const file = event.target.files[0];

        if (!file) return;

        console.log("Uploaded File:", file);
    };
    return (
        <div className="modal-content p-0">
            <div className="modal-header p-3 chat-modal-header">
                <h1 className="modal-title filter-modal-title text-center w-100">
                    New Appraisal Manual Entry
                </h1>
                <button className="sm-box-close mt-0" type="button" onClick={close}>
                    <img src={getImages('white-close.svg')} />
                </button>
            </div>
            <div className="modal-body px-0 py-5">
                <Formik
                    initialValues={{
                        date: '',
                        vin: '',
                        miles: '',
                        purchase_price: '',
                        sales_price: '',
                        source_dealer: '',
                        dealer_sold_to: '',
                        purchasing_agent: '',
                        salesman: '',
                    }}
                    onSubmit={async (values, { resetForm }) => {
                        console.log(values);
                        resetForm();
                    }}
                >
                    {({ values, setFieldValue }) => (
                        <div className='form-box'>
                            <Form autoComplete="off" name="note_form" className='custom-form'>
                                <div className='row mlr-37'>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Date</label><br />
                                            <Field name="date">
                                                {({ field }) => (
                                                    <DatePicker
                                                        {...field}
                                                        selected={values.date}
                                                        onChange={(date) => setFieldValue('date', date)}
                                                        className="form-control"
                                                        dateFormat="MM/dd/yyyy"
                                                        placeholderText="MM/dd/yyyy"
                                                    />
                                                )}
                                            </Field>
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>VIN</label>
                                            <Field
                                                type="text"
                                                name="vin"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Miles</label>
                                            <Field
                                                type="text"
                                                name="miles"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Purchase Price</label>
                                            <Field
                                                type="text"
                                                name="purchase_price"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Sales Price</label>
                                            <Field
                                                type="text"
                                                name="sales_price"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Source Dealer</label>
                                            <Field
                                                type="text"
                                                name="source_dealer"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Dealer Sold To</label>
                                            <Field
                                                type="text"
                                                name="dealer_sold_to"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Purchasing Agent</label>
                                            <Field
                                                type="text"
                                                name="purchasing_agent"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className='form-group mb-3'>
                                            <label>Salesman</label>
                                            <Field
                                                type="text"
                                                name="salesman"
                                                className='form-control'
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-3 text-center'>
                                    <button type='submit' className='red-btn text-uppercase w-300 fw-700'>Submit</button>
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
                <div className='text-center mt-5'>
                    <div className='d-inline-flex align-items-center'>
                        <div className='md-title font-1-3em'>Have an Excel File? Do an Automatic Import.</div>
                        <div className='d-inline-block position-relative'>
                            <button
                                className="red-transparent-btn text-uppercase d-inline-block text-nowrap upload-exl-btn ms-4"
                                type="button"
                                onClick={handleButtonClick}
                            >
                                <img src={getImages('file-excel-icon.png')} /> Upload File
                            </button>

                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={handleFileUpload}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewAppraisalModal